/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { isEmpty } from '../../../helpers/utils';
import { isSSR } from '@front10/utils';
import { computeDateRange } from '../../../helpers/date';
import { getOffers } from '../../../_integrations/airbnb/listings';
import { popularDestinationsToFlatFares } from '../../../_integrations/everymundo/utils/normalizeFareLikeData';
import { withCommonPreloads } from './commons/commonPreloads';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: {
          integrationSettings,
          prePopulation: {
            dateRange,
            origin,
            budget,
            homeType,
            guests,
            languageCode,
            currency,
            itemCount
          },
          meta
        }
      },
      name,
      simulateSSR
    } = cmpConfig;

    const filter = {
      origin,
      budget: budget && budget.maximum ? budget.maximum : null,
      dateRange: computeDateRange(dateRange),
      homeType,
      guests: guests && !isEmpty(guests) ? guests.adults + guests.children : 0,
      languageCode,
      currency,
      itemCount
    };

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(getOffers(filter, integrationSettings, meta));
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([other, data]) => {
        cmpConfig.containerConfig.settings.initialOffertsCard = data;
        // Fares Schema Implementation -> https://everymundo.atlassian.net/browse/FC-1700
        cmpConfig.containerConfig.settings.normalizedFlatFaresForSchema = popularDestinationsToFlatFares(
          data
        );

        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => withCommonPreloads(preloadCustomPropsExecute, cmpConfig);

export default preloadCustomProps;
